import { render, staticRenderFns } from "./Seconingfunds.vue?vue&type=template&id=152487e4&scoped=true&"
import script from "./Seconingfunds.vue?vue&type=script&lang=js&"
export * from "./Seconingfunds.vue?vue&type=script&lang=js&"
import style0 from "./Seconingfunds.vue?vue&type=style&index=0&id=152487e4&scoped=true&lang=css&"
import style1 from "./Seconingfunds.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152487e4",
  null
  
)

export default component.exports